import React from "react";
import { Paper, Typography, Box } from "@mui/material";

const OrderContactInfo = ({ customer }) => (
  <Paper
    variant="outlined"
    sx={{ p: 3, minHeight: 150 }}
    className="print-section">
    <Typography
      variant="subtitle1"
      fontWeight="bold"
      gutterBottom
      sx={{ mb: 2 }} // <-- ADD extra margin bottom after title
    >
      Contact Information
    </Typography>

    <Box mb={0.5}>
      <Typography variant="body2" fontWeight="bold">
        {customer.firstName} {customer.lastName}
      </Typography>
    </Box>

    <Box mb={0.5}>
      <Typography variant="body2">{customer.email}</Typography>
    </Box>

    <Box>
      <Typography variant="body2">{customer.phone}</Typography>
    </Box>
  </Paper>
);

export default OrderContactInfo;
